export const projects = [
  {
    id: 1,
    title: "Golden Bear",
    description: "Luxury design with rustic elements and a modern twist with high-end additions.",
    image: "https://photos.zillowstatic.com/fp/408f62793eb53f09bd5ad91804852a90-uncropped_scaled_within_1536_1152.webp",
    category: "Size",
    size: "5,400 sq ft",
    completed: "2023",
    features: [
      "Private elevator",
      "Italian Imported Porcelain Accents",
      "Custom stone fireplace",
      "Heated Bathroom Floors",
      "Expansive stone patio with outdoor kitchen"
    ],
    galleryFolder: 'project1'
  },
  {
    id: 2,
    title: "Cub Trace",
    description: "Charming farmhouse style with modern amenities and extensive outdoor living spaces",
    image: "/3.webp",
    category: "Size",
    size: "6,000 sq ft",
    completed: "2024",
    features: [
      "Private Elevator",
      "Custom stone fireplace",
      "Custom infinity pool and spa",
      "Smart home automation",
      "Motorized screen porch"
    ],
    galleryFolder: 'project2'
  },
  {
    id: 3,
    title: "Pirkle",
    description: "Sleek contemporary design with sustainable features and smart home technology",
    image: "/2.webp",
    category: "Size",
    size: "7,600 sq ft",
    completed: "2022",
    features: [
      "Reclaimed beams in living room and basement",
      "Reclaimed hardwoods throughout the home",
      "10 ft sliding door onto stone back patio",
      "Custom infinity pool and spa",
      "Motorized screen porch"
    ],
    galleryFolder: 'project3'
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Stephen Osley",
    role: "CEO",
    bio: "Stephen is the founder & CEO of Osley & Associates. During his career he has built over 750 custom homes in varying price ranges. Stephen is a graduate of the Terry College of Business at the University of Georgia and has been a custom home builder for over 34 years.",
    image: "/Stephen.webp"
  },
  {
    id: 2,
    name: "Cam Osley",
    role: "Vice President",
    bio: "Cam is a graduate of Samford University’s Brock School of Business and has a master’s degree in business administration. He is the third generation builder at Osley & Associates with his Grandfather Garry and Father Stephen.",
    image: "/Cam.webp"
  },
  {
    id: 3,
    name: "Garry Osley",
    role: "Partner",
    bio: "Garry has built over 1000+ homes in his 50+ years of experience. He also has developed some of the finer neighborhoods in North Atlanta.",
    image: "/Garry.webp"
  }
];

export const stats = [
  {
    id: 1,
    number: "750+",
    label: "Luxury Homes Built"
  },
  {
    id: 2,
    number: "34+",
    label: "Years Experience"
  }
];

export const services = [
  {
    id: 1,
    title: "Custom Home Design",
    description: "Bespoke architectural designs tailored to your lifestyle and preferences",
    icon: "🏡"
  },
  {
    id: 2,
    title: "Luxury Construction",
    description: "Premium construction services with attention to every detail",
    icon: "🔨"
  },
  {
    id: 3,
    title: "Interior Design",
    description: "Complete interior design services from concept to completion",
    icon: "🎨"
  },
  {
    id: 4,
    title: "Project Management",
    description: "Full project management ensuring timely and budget-conscious delivery",
    icon: "📋"
  }
];